import moment from "moment-timezone";
import { getMinutes } from "../../../../utilities/helpers";
import { ADDED_MARGIN_H, DEFAULT_END_HOUR, DEFAULT_START_HOUR } from "../../../../utilities/constants";

export const onSelectHourFrom = ({
    time,
    form,
    availableShiftTime,
    selectedDay,
    shiftHours,
    setShiftHours,
    isSootheMember,
    setLastDisabledHours,
    advanceBookingHours = ADDED_MARGIN_H
}) => {
    const dateFormat = "YYYY-MM-DD";
    const timeFormat = "HH:mm";

    const newTimeNow = moment().clone().add(advanceBookingHours, 'hour');
    const firstAppointmentAvailableHour = newTimeNow.hour();
    const firstAppointmentAvailableMinutes = getMinutes(newTimeNow.minute());

    const firstAppointmentEnabledHour = moment(
        availableShiftTime.start,
        timeFormat
    ).hour();
    const firstAppointmentEnabledMinutes = moment(
        availableShiftTime.start,
        timeFormat
    ).minute();
    const lastAppointmentEnabledHour = moment(
        availableShiftTime.end,
        timeFormat
    ).hour();
    const lastAppointmentEnabledMinute = moment(
        availableShiftTime.end,
        timeFormat
    ).minute();

    let startTime;
    if (isSootheMember && selectedDay && selectedDay.isSame(moment(), "day")) {
        startTime = selectedDay.set({
            hours: time.hour() < firstAppointmentEnabledHour ? firstAppointmentEnabledHour : time.hour(),
            minutes: time.hour() === firstAppointmentEnabledHour && time.minute() < firstAppointmentEnabledMinutes ? firstAppointmentEnabledMinutes : time.minute(),
        });
        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }

    if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
        if (time.hour() <= firstAppointmentEnabledHour) {
            if (firstAppointmentAvailableHour < firstAppointmentEnabledHour) {
                startTime = time.set({
                    hours: firstAppointmentEnabledHour,
                    minutes:
                        time.minute() < firstAppointmentEnabledMinutes
                            ? firstAppointmentEnabledMinutes
                            : time.minute(),
                });

                setShiftHours({
                    shiftHours: { ...shiftHours, start: startTime },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                });
                onChangeHourFrom(startTime, setLastDisabledHours);
                return;
            }
            if (firstAppointmentAvailableHour > firstAppointmentEnabledHour) {
                if (isSootheMember) {
                    startTime = time.set({
                        hours: firstAppointmentAvailableHour,
                        minutes: firstAppointmentAvailableMinutes,
                    });
                } else {
                    startTime = time.set({
                        hours:
                            moment().minutes() > 57
                                ? firstAppointmentAvailableHour + 1
                                : firstAppointmentAvailableHour,
                        minutes:
                            moment().minutes() > 57
                                ? 0
                                : getMinutes(firstAppointmentAvailableMinutes),
                    });
                }
                setShiftHours({
                    shiftHours: { ...shiftHours, start: startTime },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                });
                onChangeHourFrom(startTime, setLastDisabledHours);
                return;
            }
        }
        if (time.hour() === firstAppointmentAvailableHour) {
            if (isSootheMember) {
                startTime = time.set({
                    hours: firstAppointmentAvailableHour,
                    minute:
                        time.minute() < firstAppointmentAvailableMinutes
                            ? firstAppointmentAvailableMinutes
                            : time.minute(),
                });
            } else {
                startTime = time.set({
                    hours:
                        moment().minutes() > 57
                            ? firstAppointmentAvailableHour + 1
                            : firstAppointmentAvailableHour,
                    minutes:
                        time.minute() < firstAppointmentAvailableMinutes
                            ? getMinutes(firstAppointmentAvailableMinutes)
                            : time.minute(),
                });
            }
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() >= lastAppointmentEnabledHour) {
            startTime = time.set({
                hours: lastAppointmentEnabledHour - 1,
                minutes: lastAppointmentEnabledMinute,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() < firstAppointmentAvailableHour) {
            if (isSootheMember) {
                startTime = time.set({
                    hours: firstAppointmentAvailableHour,
                    minute: firstAppointmentAvailableMinutes,
                });
            } else {
                startTime = time.set({
                    hours:
                        moment().minutes() > 57
                            ? firstAppointmentAvailableHour + 1
                            : firstAppointmentAvailableHour,
                    minutes:
                        moment().minutes() > 57
                            ? 0
                            : getMinutes(firstAppointmentAvailableMinutes),
                });
            }
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() === lastAppointmentEnabledHour) {
            startTime = time.set({
                hours: time.hour(),
            });

            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }
        if (time.hour() === firstAppointmentEnabledHour) {
            startTime = time.set({
                hours: firstAppointmentEnabledHour,
                minutes: time.minute(),
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }
    }

    if (time.hour() === moment(availableShiftTime.start, "HH:mm").hour()) {
        startTime = time.set({
            hours: moment(availableShiftTime.start, "HH:mm").hour(),
            minute:
                time.minute() < moment(availableShiftTime.start, "HH:mm").minute()
                    ? moment(availableShiftTime.start, "HH:mm").minute()
                    : time.minute(),
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });

        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }
    if (time.hour() < moment(availableShiftTime.start, "HH:mm").hour()) {
        startTime = time.set({
            hours: moment(availableShiftTime.start, "HH:mm").hour(),
            minute: moment(availableShiftTime.start, "HH:mm").minute(),
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });

        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }

    if (time.hour() >= moment(availableShiftTime.end, "HH:mm").hour()) {
        if (
            time.hour() >= moment(shiftHours.end, "HH:mm").hour() &&
            moment(shiftHours.end, "HH:mm").hour() !== 0
        ) {
            startTime = time.set({
                hours: moment(shiftHours.end, "HH:mm").hour() - 1,
                minute: 0,
            });
        } else {
            startTime = time.set({
                hours: moment(availableShiftTime.end, "HH:mm").hour() - 1,
                minute: 0,
            });
        }
        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }
    if (
        time.hour() >= moment(shiftHours.end, "HH:mm").hour() &&
        moment(shiftHours.end, "HH:mm").hour() !== 0
    ) {
        startTime = time.set({
            hours: moment(shiftHours.end, "HH:mm").hour() - 1,
            minute: 0,
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }

    setShiftHours({
        shiftHours: { ...shiftHours, start: time },
    });
    form.setFieldsValue({
        "start-time": time,
    });
    onChangeHourFrom(time, setLastDisabledHours);
    return;
};
export const onSelectHourFromNew = ({
    time,
    form,
    availableShiftTime,
    selectedDay,
    shiftHours,
    setShiftHours,
    isSootheMember,
    setLastDisabledHours,
    advanceBookingHours = ADDED_MARGIN_H
}) => {
    const tempEnd = shiftHours.end ? shiftHours.end?.clone() : shiftHours.end;
    const newTimeNow = moment().clone().add(advanceBookingHours, 'hour');
    const firstAppointmentAvailableHour = newTimeNow.hour();
    const firstAppointmentAvailableMinutes = getMinutes(newTimeNow.minute());

    const firstAppointmentEnabledHour = availableShiftTime.start?.hour();
    const firstAppointmentEnabledMinutes = availableShiftTime.start?.minute();
    const lastAppointmentEnabledHour = availableShiftTime.end?.hour();
    const lastAppointmentEnabledMinute = availableShiftTime.end?.minute();

    let startTime;
    if (isSootheMember && selectedDay && selectedDay.isSame(moment(), "day")) {
        startTime = selectedDay.set({
            hours: time.hour() < firstAppointmentEnabledHour ? firstAppointmentEnabledHour : time.hour(),
            minutes: time.hour() === firstAppointmentEnabledHour && time.minute() < firstAppointmentEnabledMinutes ? firstAppointmentEnabledMinutes : time.minute(),
        });
        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        // todo revisit 1 line above
        return;
    }

    if (selectedDay?.isSame(moment(), "day")) {
        if (time.hour() <= firstAppointmentEnabledHour) {
            if (firstAppointmentAvailableHour < firstAppointmentEnabledHour) {
                startTime = time.set({
                    hours: firstAppointmentEnabledHour,
                    minutes:
                        time.minute() < firstAppointmentEnabledMinutes
                            ? firstAppointmentEnabledMinutes
                            : time.minute(),
                });

                setShiftHours({
                    shiftHours: { ...shiftHours, start: startTime },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                });
                onChangeHourFrom(startTime, setLastDisabledHours);
                return;
            }
            if (firstAppointmentAvailableHour > firstAppointmentEnabledHour) {
                startTime = time.set({
                    hours:
                        moment().minutes() > 57
                            ? firstAppointmentAvailableHour + 1
                            : firstAppointmentAvailableHour,
                    minutes:
                        moment().minutes() > 57
                            ? 0
                            : getMinutes(firstAppointmentAvailableMinutes),
                });
                setShiftHours({
                    shiftHours: { ...shiftHours, start: startTime },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                });
                onChangeHourFrom(startTime, setLastDisabledHours);
                return;
            }
        }
        if (time.hour() === firstAppointmentAvailableHour) {
            startTime = time.set({
                hours:
                    moment().minutes() > 57
                        ? firstAppointmentAvailableHour + 1
                        : firstAppointmentAvailableHour,
                minutes:
                    time.minute() < firstAppointmentAvailableMinutes
                        ? getMinutes(firstAppointmentAvailableMinutes)
                        : time.minute(),
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() >= lastAppointmentEnabledHour) {
            startTime = time.set({
                hours: lastAppointmentEnabledHour - 1,
                minutes: lastAppointmentEnabledMinute,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() < firstAppointmentAvailableHour) {
            startTime = time.set({
                hours:
                    moment().minutes() > 57
                        ? firstAppointmentAvailableHour + 1
                        : firstAppointmentAvailableHour,
                minutes:
                    moment().minutes() > 57
                        ? 0
                        : getMinutes(firstAppointmentAvailableMinutes),
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }

        if (time.hour() === lastAppointmentEnabledHour) {
            startTime = time.set({
                hours: time.hour(),
            });

            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }
        if (time.hour() === firstAppointmentEnabledHour) {
            startTime = time.set({
                hours: firstAppointmentEnabledHour,
                minutes: time.minute(),
            });
            setShiftHours({
                shiftHours: { ...shiftHours, start: startTime },
            });

            form.setFieldsValue({
                "start-time": startTime,
            });
            onChangeHourFrom(startTime, setLastDisabledHours);
            return;
        }
    }

    if (availableShiftTime.start && time.hour() === availableShiftTime.start.hour()) {
        startTime = time.set({
            hours: availableShiftTime.start.hour(),
            minute:
                time.minute() < availableShiftTime.start.minute()
                    ? availableShiftTime.start.minute()
                    : time.minute(),
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });

        // TODO revisit 1 line below role
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }
    if (availableShiftTime.start && time.hour() < availableShiftTime.start.hour()) {
        startTime = time.set({
            hours: availableShiftTime.start.hour(),
            minute: availableShiftTime.start.minute(),
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });

        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }

    if (time.hour() >= moment(availableShiftTime.end, "HH:mm").hour()) {
        if (
            time.hour() >= moment(tempEnd, "HH:mm").hour() &&
            moment(tempEnd, "HH:mm").hour() !== 0
        ) {
            startTime = time.set({
                hours: moment(tempEnd, "HH:mm").hour() - 1,
                minute: 0,
            });
        } else {
            startTime = time.set({
                hours: moment(availableShiftTime.end, "HH:mm").hour() - 1,
                minute: 0,
            });
        }
        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }
    if (
        time.hour() >= moment(tempEnd, "HH:mm").hour() &&
        moment(tempEnd, "HH:mm").hour() !== 0
    ) {
        startTime = time.set({
            hours: moment(tempEnd, "HH:mm").hour() - 1,
            minute: 0,
        });

        setShiftHours({
            shiftHours: { ...shiftHours, start: startTime },
        });

        form.setFieldsValue({
            "start-time": startTime,
        });
        onChangeHourFrom(startTime, setLastDisabledHours);
        return;
    }

    setShiftHours({
        shiftHours: { ...shiftHours, start: time },
    });
    form.setFieldsValue({
        "start-time": time,
    });
    onChangeHourFrom(time, setLastDisabledHours);
    return;
};
export const onChangeHourFrom = (time, setLastDisabledHours) => {
    let disabled = [];
    for (let i = 0; i < moment(time).hours(); i++) {
        disabled.push(i);
    }
    setLastDisabledHours(disabled);
};

export const onChangeHourTill = (time, setFirstDisabledHours) => {
    let disabled = [];
    for (let i = moment(time).clone().add(1, "hours").hours(); i < DEFAULT_END_HOUR; i++) {
        disabled.push(i);
    }
    setFirstDisabledHours(disabled);
};

export const onSelectHourTill = ({
    time,
    form,
    availableShiftTime,
    shiftHours,
    setShiftHours,
    selectedDay,
    setFirstDisabledHours,
    advanceBookingHours = ADDED_MARGIN_H,
}) => {
    const firstAppointmentAvailableHour = shiftHours.start
        ? shiftHours.start.hour()
        : moment().hour() + advanceBookingHours;
    const firstAppointmentAvailableMinutes = shiftHours.start
        ? shiftHours.start.minute()
        : moment().minute();

    const firstAppointmentEnabledHour = availableShiftTime.start?.hour();
    const lastAppointmentEnabledHour = availableShiftTime.end?.hour();
    const lastAppointmentEnabledMinutes = availableShiftTime.end?.minute();
    if (selectedDay?.isSame(moment(), "day")) {
        if (time.hour() === firstAppointmentAvailableHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour,
                minutes: firstAppointmentAvailableMinutes
            }).clone().add(5, "minutes");

            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });

            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }
        if (time.hour() < firstAppointmentEnabledHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour + 1,
                // minutes:
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() > lastAppointmentEnabledHour) {
            let endTime = time.set({
                hours: lastAppointmentEnabledHour,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() < firstAppointmentAvailableHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour + 1,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }
        if (time.hour() === lastAppointmentEnabledHour) {
            let endTime = time.set({
                hours: time.hour(),
                minute: lastAppointmentEnabledMinutes,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() === moment(shiftHours.start, "HH:mm").hour()) {
            let endTime = time.set({
                hours: moment(shiftHours.start, "HH:mm").hour(),
                minutes: moment(shiftHours.start, "HH:mm").minute(),
            }).clone().add(5, "minutes");
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
        }
    }

    if (availableShiftTime.start && time.hour() < availableShiftTime.start.hour()) {
        let endTime = time.set({
            hours: availableShiftTime.start.hour(),
            minute: availableShiftTime.start.minute(),
        }).clone().add(5, "minutes");
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }
    if (time.hour() <= moment(shiftHours.start, "HH:mm").hour()) {
        let endTime = time.clone().set({
            hours: moment(shiftHours.start, "HH:mm").hour(),
            minute: moment(shiftHours.start, "HH:mm").minute(),
        }).clone().add(5, "minutes");
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }
    if (time.hour() >= moment(availableShiftTime.end, "HH:mm").hour()) {
        let endTime = time.set({
            hours: moment(availableShiftTime.end, "HH:mm").hour(),
            minute: time.minute() <= moment(availableShiftTime.end, "HH:mm").minute() ? time.minute() : moment(availableShiftTime.end, "HH:mm").minute(),
        });
        // .format("HH:mm");
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }

    setShiftHours({
        shiftHours: { ...shiftHours, end: time },
    });
    form.setFieldsValue({
        "end-time": time,
    });
    onChangeHourTill(time, setFirstDisabledHours);
};
export const onSelectHourTillNew = ({
    time,
    form,
    availableShiftTime,
    shiftHours,
    setShiftHours,
    selectedDay,
    setFirstDisabledHours,
    advanceBookingHours = ADDED_MARGIN_H,
}) => {
    const tempStart = shiftHours.start ? shiftHours.start?.clone() : availableShiftTime.start;
    const firstAppointmentAvailableHour = tempStart
        ? tempStart?.hour()
        : moment().hour() + advanceBookingHours;

    const firstAppointmentEnabledHour = availableShiftTime.start?.hour();
    const lastAppointmentEnabledHour = availableShiftTime.end?.hour();
    const lastAppointmentEnabledMinutes = availableShiftTime.end?.minute();
    if (selectedDay?.isSame(moment(), "day")) {
        if (time.hour() === firstAppointmentAvailableHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour + 1,
            });

            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });

            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }
        if (time.hour() < firstAppointmentEnabledHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour + 1,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() > lastAppointmentEnabledHour) {
            let endTime = time.set({
                hours: lastAppointmentEnabledHour,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() < firstAppointmentAvailableHour) {
            let endTime = time.set({
                hours: firstAppointmentAvailableHour + 1,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }
        if (time.hour() === lastAppointmentEnabledHour) {
            let endTime = time.set({
                hours: time.hour(),
                minute: lastAppointmentEnabledMinutes,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
            return;
        }

        if (time.hour() === tempStart.hour()) {
            let endTime = time.set({
                hours: tempStart.hour() + 1,
            });
            setShiftHours({
                shiftHours: { ...shiftHours, end: endTime },
            });
            form.setFieldsValue({
                "end-time": endTime,
            });
            onChangeHourTill(endTime, setFirstDisabledHours);
        }
    }

    if (availableShiftTime.start && time.hour() < availableShiftTime.start.hour()) {
        let endTime = time.set({
            hours: availableShiftTime.start.hour() + 1,
            minute: availableShiftTime.start.minute(),
        });
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }
    if (time.hour() <= tempStart.hour()) {
        let endTime = time.set({
            hours: tempStart.hour() + 1,
            minute: tempStart.add(1, "hours").minute(),
        });
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }
    if (availableShiftTime.end && time.hour() >= availableShiftTime.end.hour()) {
        let endTime = time.set({
            hours: availableShiftTime.end.hour(),
            minute: time.minute() <= availableShiftTime.end.minute() ? time.minute() : availableShiftTime.end.minute(),
        });
        setShiftHours({
            shiftHours: { ...shiftHours, end: endTime },
        });
        form.setFieldsValue({
            "end-time": endTime,
        });
        onChangeHourTill(endTime, setFirstDisabledHours);
    }

    setShiftHours({
        shiftHours: { ...shiftHours, end: time },
    });
    form.setFieldsValue({
        "end-time": time,
    });
    onChangeHourTill(time, setFirstDisabledHours);
};

export const fromDisabledTime = ({
    availableShiftTime,
    firstDisabledHours,
    fixedDisabledHours,
    endShiftTime,
    selectedDay,
    isSootheMember,
    hasPostShiftPermission,
    isCorporateWellness,
    hasDigitalScheduler,
    advanceBookingHours = ADDED_MARGIN_H,
}) => {
    const timeFormat = "HH:mm";
    const dateFormat = "YYYY-MM-DD";
    const firstAppointmentEnabledHour = moment(
        availableShiftTime?.start,
        timeFormat
    ).hour();
    const lastAppointmentEnabledHour = moment(
        availableShiftTime?.end,
        timeFormat
    ).hour();
    return {
        disabledHours: () => {
            let disabled = [...firstDisabledHours];

            for (
                let i = moment(availableShiftTime.end, "HH:mm").hours();
                i <= DEFAULT_END_HOUR;
                i++
            ) {
                disabled.push(i);
            }
            for (
                let i = DEFAULT_START_HOUR;
                i < moment(availableShiftTime.start, "HH:mm").hours();
                i++
            ) {
                disabled.push(i);
            }
            
            // Allow past times for corporate users with post shift permission
            // ONLY when digital scheduler is disabled
            if (hasPostShiftPermission && isCorporateWellness && !hasDigitalScheduler) {
                return fixedDisabledHours.concat(disabled)
            }
            
            // Original logic for non-corporate or users without post shift permission
            if (hasPostShiftPermission && !isCorporateWellness) {
                return fixedDisabledHours.concat(disabled)
            }

            for (
                let i = endShiftTime.hours();
                i <= moment(availableShiftTime.end, "HH:mm").hours();
                i++
            ) {
                if (endShiftTime.hours() !== 0) {
                    disabled.push(i);
                }
            }

            if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
                for (
                    let i = firstAppointmentEnabledHour;
                    i <= lastAppointmentEnabledHour;
                    i++
                ) {
                    if (isSootheMember) {
                        if (i < moment().hours()) {
                            disabled.push(i);
                        }
                        if (i === moment().hours() && moment().minutes() > 55) {
                            disabled.push(i);
                        }
                    } else {
                        if (i < moment().hours() + advanceBookingHours) {
                            disabled.push(i);
                        }
                        if (i === moment().hours() + advanceBookingHours && moment().minutes() > 55) {
                            disabled.push(i);
                        }
                    }
                }
            }

            return fixedDisabledHours.concat(disabled);
        },
        disabledMinutes: (selectedHour) => {
            const timeFormat = "HH:mm";
            const dateFormat = "YYYY-MM-DD";
            const availbleTimeRange = availableShiftTime;
            const firstAppointmentEnabledTime = moment(
                availbleTimeRange?.start,
                timeFormat
            );
            const lastAppointmentEnabledTime = moment(
                availbleTimeRange?.end,
                timeFormat
            );
            if (moment(availableShiftTime.end, "HH:mm").hour() === selectedHour) {
                for (let i = moment(availableShiftTime.end, "HH:mm").minute(); i < 59; i++) {
                    minutes.push(i);
                }
            }
            if (!availbleTimeRange) return;
            let minutes = [];
            if (selectedHour < 0) {
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === firstAppointmentEnabledTime.hour()) {
                for (let i = firstAppointmentEnabledTime.minute() - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            } else if (selectedHour === lastAppointmentEnabledTime.hour()) {
                for (let i = lastAppointmentEnabledTime.minute() + 1; i <= 60; i++) {
                    minutes.push(i);
                }
            }

            if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
                if (isSootheMember) {
                    if (selectedHour === moment().hour()) {
                        for (let i = 0; i < moment().minute() + 30; i++) {
                            if (i <= 30) {
                                minutes.push(i);
                            }
                        }
                    } else if (selectedHour - 1 === moment().hour()) {
                        for (let i = 0; i < moment().minute() - 30; i++) {
                            if (i % 5 === 0) {
                                minutes.push(i);
                            }
                        }
                    }
                } else {
                    if (selectedHour === moment().hour() + advanceBookingHours) {
                        for (let i = 0; i < moment().minute(); i++) {
                            minutes.push(i);
                        }
                    }
                }
            }

            return minutes;
        },
    };
};

export const fromDisabledTimeNew = ({
    availableShiftTime,
    firstDisabledHours,
    fixedDisabledHours,
    endShiftTime,
    selectedDay,
    isSootheMember,
    advanceBookingHours = ADDED_MARGIN_H
}) => {
    const firstAppointmentEnabledHour = availableShiftTime?.start;
    const lastAppointmentEnabledHour = availableShiftTime?.end;
    const hoursToAdd = isSootheMember ? 0 : advanceBookingHours;
    return {
        disabledHours: () => {
            let disabled = [...firstDisabledHours];

            // NB: if we assumed that the default end is later than the last appointment enabled hour
            for (
                let i = lastAppointmentEnabledHour.hours();
                i <= DEFAULT_END_HOUR;
                i++
            ) {
                disabled.push(i);
            }

            // NB: if we assumed that the default start is earlier than the first appointment enabled hour
            for (
                let i = DEFAULT_START_HOUR;
                i < firstAppointmentEnabledHour.hours();
                i++
            ) {
                disabled.push(i);
            }
            // TODO the below is not working as expected 
            if (endShiftTime) {
                for (
                    let i = endShiftTime.hours();
                    i <= lastAppointmentEnabledHour.hours();
                    i++
                ) {
                    if (endShiftTime.hours() !== 0) {
                        disabled.push(i);
                    }
                }
            }

            if (selectedDay && selectedDay.isSame(moment(), "day")) {
                for (
                    let i = firstAppointmentEnabledHour.clone();
                    i.isSameOrBefore(lastAppointmentEnabledHour, "hour");
                    i.add(1, "hour")
                ) {
                    if (i.isBefore(moment().add(hoursToAdd, "hour"), "hour")) {
                        disabled.push(i.hours());
                    } else if (i.isSame(moment().add(hoursToAdd, "hour"), "hour") && ((moment().minutes() > 57 && !isSootheMember) || (isSootheMember && moment().minutes() > 5))) {
                        disabled.push(i.hours());
                    }
                }
            }

            return fixedDisabledHours.concat(disabled);
        },
        disabledMinutes: (selectedHour) => {
            const timeFormat = "HH:mm";
            const dateFormat = "YYYY-MM-DD";
            const availbleTimeRange = availableShiftTime;
            const firstAppointmentEnabledTime = availbleTimeRange?.start;
            const lastAppointmentEnabledTime = availbleTimeRange?.end;
            let minutes = [];

            if (selectedHour < 0 || !availbleTimeRange) {
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === firstAppointmentEnabledTime.hour()) {
                for (let i = firstAppointmentEnabledTime.minute() - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            } else if (selectedHour === lastAppointmentEnabledTime.hour()) {
                for (let i = lastAppointmentEnabledTime.minute() + 1; i <= 60; i++) {
                    minutes.push(i);
                }
            }

            if (selectedDay?.isSame(moment(), "day")) {
                if (isSootheMember) {
                    if (selectedHour === moment().hour()) {
                        // TODO: check if the below is correct, it's old and seems illogical
                        for (let i = 0; i < moment().minute() + 30; i++) {
                            if (i <= 30) {
                                minutes.push(i);
                            }
                        }
                    } else if (selectedHour - 1 === moment().hour()) {
                        // TODO recheck, seems illogical
                        for (let i = 0; i < moment().minute() - 30; i++) {
                            if (i % 5 === 0) {
                                minutes.push(i);
                            }
                        }
                    }
                } else {
                    if (selectedHour === moment().hour() + advanceBookingHours) {
                        for (let i = 0; i < moment().minute(); i++) {
                            minutes.push(i);
                        }
                    }
                }
            }

            return minutes;
        },
    };
};

export const correctStartTime = ({ start, disabledHoursFunc, disabledMinutesFunc, updateStartTime }) => {
    let tempStart = start.clone();
    let disabledHours = disabledHoursFunc();
    while (disabledHours.includes(tempStart.hours())) {
        tempStart = tempStart.set({ minute: 0 }).clone().add(1, 'hour');
    }
    let disabledMinutes = disabledMinutesFunc(tempStart.hours());
    while (disabledMinutes.includes(tempStart.minutes())) {
        tempStart = tempStart.clone().add(5, 'minute');
    }

    if (!tempStart.isSame(start)) {
        updateStartTime(tempStart);
    }
}

export const correctEndTime = ({ }) => {

}


export const lastDisabledTime = ({
    availableShiftTime,
    lastDisabledHours,
    fixedDisabledHours,
    startShiftTime,
    selectedDay,
    isSootheMember,
    hasPostShiftPermission,
    isCorporateWellness,
    hasDigitalScheduler,
    advanceBookingHours = ADDED_MARGIN_H,
}) => {
    return {
        disabledHours: () => {
            const timeFormat = "HH:mm";
            const dateFormat = "YYYY-MM-DD";

            const firstAppointmentEnabledHour = moment(
                availableShiftTime?.start,
                timeFormat
            ).hour();
            const lastAppointmentEnabledHour = moment(
                availableShiftTime?.end,
                timeFormat
            ).hour();
            let disabled = [...lastDisabledHours];

            for (
                let i = DEFAULT_START_HOUR;
                i < moment(availableShiftTime.start, "HH:mm").hours();
                i++
            ) {
                disabled.push(i);
            }

            for (
                let i = moment(availableShiftTime.end, "HH:mm").hours() + 1;
                i <= DEFAULT_END_HOUR;
                i++
            ) {
                disabled.push(i);
            }

            for (
                let i = moment(availableShiftTime.start, "HH:mm").hours() + 1;
                i < startShiftTime.hours();
                i++
            ) {
                disabled.push(i);
            }
            
            // For corporate users with post shift permission, allow past times
            // ONLY when digital scheduler is disabled
            if (hasPostShiftPermission && isCorporateWellness && !hasDigitalScheduler) {
                return fixedDisabledHours.concat(disabled);
            }
            
            if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
                if (!isSootheMember)
                    for (
                        let i = firstAppointmentEnabledHour;
                        i <= lastAppointmentEnabledHour;
                        i++
                    ) {
                        if (i < moment().hours() + advanceBookingHours) {
                            disabled.push(i);
                        }
                    }
            }
            return fixedDisabledHours.concat(disabled);
        },
        disabledMinutes: (selectedHour) => {
            const timeFormat = "HH:mm";
            const dateFormat = "YYYY-MM-DD";
            const availbleTimeRange = availableShiftTime;
            const firstAppointmentEnabledTime = moment(
                availbleTimeRange?.start,
                timeFormat
            );
            const lastAppointmentEnabledTime = moment(
                availbleTimeRange?.end,
                timeFormat
            );
            if (!availbleTimeRange) return;
            let minutes = [];

            if (selectedHour < 0) {
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === firstAppointmentEnabledTime.hour()) {
                for (let i = firstAppointmentEnabledTime.minute() - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            } else if (selectedHour === lastAppointmentEnabledTime.hour()) {
                for (let i = lastAppointmentEnabledTime.minute() + 1; i <= 60; i++) {
                    minutes.push(i);
                }
            }
            if (moment().format(dateFormat) === selectedDay) {
                if (selectedHour === moment().hour() + advanceBookingHours) {
                    for (let i = 0; i < moment().minute(); i++) {
                        minutes.push(i);
                    }
                }
            }

            return minutes;
        },
    };
};

export const lastDisabledTimeNew = ({
    availableShiftTime,
    lastDisabledHours,
    fixedDisabledHours,
    startShiftTime,
    selectedDay,
    isSootheMember,
    advanceBookingHours = ADDED_MARGIN_H
}) => {
    return {
        disabledHours: () => {
            const hrsToAdd = isSootheMember ? 0 : advanceBookingHours;
            const firstAppointmentEnabledHour = availableShiftTime?.start?.hour();
            const lastAppointmentEnabledHour = availableShiftTime?.end?.hour();
            let disabled = [...lastDisabledHours];

            for (
                let i = DEFAULT_START_HOUR;
                i <= availableShiftTime.start?.hour();
                i++
            ) {
                disabled.push(i);
            }

            for (
                let i = availableShiftTime.end?.hour() + 1;
                i <= DEFAULT_END_HOUR;
                i++
            ) {
                disabled.push(i);
            }

            for (
                let i = availableShiftTime.start?.hour() + 1;
                i <= startShiftTime.hour();
                i++
            ) {
                disabled.push(i);
            }
            if (selectedDay?.isSame(moment(), "day")) {
                for (
                    let i = firstAppointmentEnabledHour;
                    i <= lastAppointmentEnabledHour;
                    i++
                ) {
                    if (i < moment().hour() + hrsToAdd + 1) {
                        disabled.push(i);
                    }
                }
            }
            return fixedDisabledHours.concat(disabled);
        },
        disabledMinutes: (selectedHour) => {
            const hrsToAdd = isSootheMember ? 0 : advanceBookingHours;
            const availbleTimeRange = availableShiftTime;
            const firstAppointmentEnabledTime = availbleTimeRange?.start;
            const lastAppointmentEnabledTime = availbleTimeRange?.end;
            let minutes = [];

            if (selectedHour < 0 || !availbleTimeRange) {
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === firstAppointmentEnabledTime.hour()) {
                for (let i = firstAppointmentEnabledTime.minute() - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            } else if (selectedHour === lastAppointmentEnabledTime.hour()) {
                for (let i = lastAppointmentEnabledTime.minute() + 1; i <= 60; i++) {
                    minutes.push(i);
                }
            }
            if (selectedDay?.isSame(moment(), "day")) {
                if (selectedHour === moment().hour() + hrsToAdd) {
                    for (let i = 0; i < moment().minute(); i++) {
                        minutes.push(i);
                    }
                }
            }

            return minutes;
        },
    };
};

export const onSelectStartTime = ({
    time,
    setFormData,
    availableShiftTime,
    selectedDay,
    form,
    shiftHours,
    isSootheMember,
    advanceBookingHours = ADDED_MARGIN_H
}) => {
    const dateFormat = "YYYY-MM-DD";
    const timeFormat = "HH:mm";

    const newTimeNow = moment().clone().add(advanceBookingHours, 'hour');
    const firstAppointmentAvailableHour = newTimeNow.hour();
    const firstAppointmentAvailableMinutes = getMinutes(newTimeNow.minute());

    const firstAppointmentEnabledHour = moment(
        availableShiftTime.start,
        timeFormat
    ).hour();
    const firstAppointmentEnabledMinutes = moment(
        availableShiftTime.start,
        timeFormat
    ).minute();

    const lastAppointmentEnabledHour = moment(
        availableShiftTime.end,
        timeFormat
    ).hour();
    const lastAppointmentEnabledMinutes = moment(
        availableShiftTime.end,
        timeFormat
    ).minute();

    if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
        if (time.hour() <= firstAppointmentEnabledHour) {
            if (firstAppointmentAvailableHour < firstAppointmentEnabledHour) {
                let startTime = time.set({
                    hours: firstAppointmentEnabledHour,
                    minutes:
                        time.minute() < firstAppointmentEnabledMinutes
                            ? firstAppointmentEnabledMinutes
                            : time.minute(),
                });

                let endTime = moment(startTime, "HH:mm").clone().add(
                    moment.duration(shiftHours.diff, "hours")
                );

                setFormData({
                    shiftHours: {
                        ...shiftHours,
                        start: startTime.format("HH:mm"),
                        end: endTime.format("HH:mm"),
                    },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                    "end-time": endTime,
                });

                return;
            }
            if (firstAppointmentAvailableHour > firstAppointmentEnabledHour) {
                if (isSootheMember) {
                    let startTime = time.set({
                        hours: firstAppointmentAvailableHour,
                        minutes: firstAppointmentAvailableMinutes,
                    });

                    let endTime = moment(startTime, "HH:mm").clone().add(
                        moment.duration(shiftHours.diff, "hours")
                    );

                    setFormData({
                        shiftHours: {
                            ...shiftHours,
                            start: startTime.format("HH:mm"),
                            end: endTime.format("HH:mm"),
                        },
                    });

                    form.setFieldsValue({
                        "start-time": startTime,
                        "end-time": endTime,
                    });
                    return;
                } else {
                    let startTime = time.set({
                        hours:
                            moment().minutes() > 57
                                ? firstAppointmentAvailableHour + 1
                                : firstAppointmentAvailableHour,
                        minutes:
                            moment().minutes() > 57
                                ? 0
                                : getMinutes(firstAppointmentAvailableMinutes),
                    });

                    let endTime = moment(startTime, "HH:mm").clone().add(
                        moment.duration(shiftHours.diff, "hours")
                    );

                    setFormData({
                        shiftHours: {
                            ...shiftHours,
                            start: startTime.format("HH:mm"),
                            end: endTime.format("HH:mm"),
                        },
                    });

                    form.setFieldsValue({
                        "start-time": startTime,
                        "end-time": endTime,
                    });
                }
                return;
            }
        }

        if (time.hour() === firstAppointmentAvailableHour) {
            if (isSootheMember) {
                let startTime = time.set({
                    hours: firstAppointmentAvailableHour,
                    minute:
                        time.minute() < firstAppointmentAvailableMinutes
                            ? firstAppointmentAvailableMinutes
                            : time.minute(),
                });

                let endTime = moment(startTime, "HH:mm").clone().add(
                    moment.duration(shiftHours.diff, "hours")
                );
                setFormData({
                    shiftHours: {
                        ...shiftHours,
                        start: startTime.format("HH:mm"),
                        end: endTime.format("HH:mm"),
                    },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                    "end-time": endTime,
                });
            } else {
                let startTime = time.set({
                    hours:
                        moment().minutes() > 57
                            ? firstAppointmentAvailableHour + 1
                            : firstAppointmentAvailableHour,
                    minutes:
                        time.minute() < firstAppointmentAvailableMinutes
                            ? getMinutes(firstAppointmentAvailableMinutes)
                            : time.minute(),
                });

                let endTime = moment(startTime, "HH:mm").clone().add(
                    moment.duration(shiftHours.diff, "hours")
                );

                setFormData({
                    shiftHours: {
                        ...shiftHours,
                        start: startTime.format("HH:mm"),
                        end: endTime.format("HH:mm"),
                    },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                    "end-time": endTime,
                });
            }
            return;
        }

        if (time.hour() >= lastAppointmentEnabledHour) {
            let startTime = time.set({
                hours: lastAppointmentEnabledHour - 1,
                minutes: lastAppointmentEnabledMinutes,
            });

            let endTime = moment(startTime, "HH:mm").clone().add(
                moment.duration(shiftHours.diff, "hours")
            );

            setFormData({
                shiftHours: {
                    ...shiftHours,
                    start: startTime.format("HH:mm"),
                    end: endTime.format("HH:mm"),
                },
            });

            form.setFieldsValue({
                "start-time": startTime,
                "end-time": endTime,
            });

            return;
        }

        if (time.hour() < firstAppointmentAvailableHour) {
            if (isSootheMember) {
                let startTime = time.set({
                    hours: firstAppointmentAvailableHour,
                    minute: firstAppointmentAvailableMinutes,
                });

                let endTime = moment(startTime, "HH:mm").clone().add(
                    moment.duration(shiftHours.diff, "hours")
                );

                setFormData({
                    shiftHours: {
                        ...shiftHours,
                        start: startTime.format("HH:mm"),
                        end: endTime.format("HH:mm"),
                    },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                    "end-time": endTime,
                });
            } else {
                let startTime = time.set({
                    hours:
                        moment().minutes() > 57
                            ? firstAppointmentAvailableHour + 1
                            : firstAppointmentAvailableHour,
                    minutes:
                        moment().minutes() > 57
                            ? 0
                            : getMinutes(firstAppointmentAvailableMinutes),
                });

                let endTime = moment(startTime, "HH:mm").clone().add(
                    moment.duration(shiftHours.diff, "hours")
                );

                setFormData({
                    shiftHours: {
                        ...shiftHours,
                        start: startTime.format("HH:mm"),
                        end: endTime.format("HH:mm"),
                    },
                });

                form.setFieldsValue({
                    "start-time": startTime,
                    "end-time": endTime,
                });
            }
            return;
        }

        // i'm here
        if (time.hour() === lastAppointmentEnabledHour) {
            let startTime = time.set({
                hours: time.hour(),
            });

            let endTime = moment(startTime, "HH:mm").clone().add(
                moment.duration(shiftHours.diff, "hours")
            );

            setFormData({
                shiftHours: {
                    ...shiftHours,
                    start: startTime.format("HH:mm"),
                    end: endTime.format("HH:mm"),
                },
            });

            form.setFieldsValue({
                "start-time": startTime,
                "end-time": endTime,
            });
        }

        if (time.hour() === firstAppointmentEnabledHour) {
            let startTime = time.set({
                hours: firstAppointmentEnabledHour,
                minutes: time.minute(),
            });

            let endTime = moment(startTime, "HH:mm").clone().add(
                moment.duration(shiftHours.diff, "hours")
            );

            setFormData({
                shiftHours: {
                    ...shiftHours,
                    start: startTime.format("HH:mm"),
                    end: endTime.format("HH:mm"),
                },
            });

            form.setFieldsValue({
                "start-time": startTime,
                "end-time": endTime,
            });

            return;
        }
    }

    if (time.hour() === moment(availableShiftTime.start, "HH:mm").hour()) {
        let startTime = time.set({
            hours: moment(availableShiftTime.start, "HH:mm").hour(),
            minute:
                time.minute() < moment(availableShiftTime.start, "HH:mm").minute()
                    ? moment(availableShiftTime.start, "HH:mm").minute()
                    : time.minute(),
        });

        let endTime = moment(startTime, "HH:mm").clone().add(
            moment.duration(shiftHours.diff, "hours")
        );

        setFormData({
            shiftHours: {
                ...shiftHours,
                start: startTime.format("HH:mm"),
                end: endTime.format("HH:mm"),
            },
        });

        form.setFieldsValue({
            "start-time": startTime,
            "end-time": endTime,
        });
        // return time
        //   .set({
        //     hours: moment(availableShiftTime.start, "HH:mm").hour(),
        //     minute:
        //       time.minute() < moment(availableShiftTime.start, "HH:mm").minute()
        //         ? moment(availableShiftTime.start, "HH:mm").minute()
        //         : time.minute(),
        //   })
        //   .format("HH:mm");

        return;
    }

    if (time.hour() < moment(availableShiftTime.start, "HH:mm").hour()) {
        let startTime = time.set({
            hours: moment(availableShiftTime.start, "HH:mm").hour(),
            minute: moment(availableShiftTime.start, "HH:mm").minute(),
        });

        let endTime = moment(startTime, "HH:mm").clone().add(
            moment.duration(shiftHours.diff, "hours")
        );

        setFormData({
            shiftHours: {
                ...shiftHours,
                start: startTime.format("HH:mm"),
                end: endTime.format("HH:mm"),
            },
        });

        form.setFieldsValue({
            "start-time": startTime,
            "end-time": endTime,
        });

        // return time
        //   .set({
        //     hours: moment(availableShiftTime.start, "HH:mm").hour(),
        //     minute: moment(availableShiftTime.start, "HH:mm").minute(),
        //   })
        //   .format("HH:mm");
    }

    if (time.hour() >= moment(availableShiftTime.end, "HH:mm").hour()) {
        // if (
        //   time.hour() >= moment(shiftHours.end, "HH:mm").hour() &&
        //   moment(shiftHours.end, "HH:mm").hour() !== 0
        // ) {
        //   return time
        //     .set({
        //       hours: moment(shiftHours.end, "HH:mm").hour() - 1,
        //       minute: 0,
        //     })
        //     .format("HH:mm");
        // }

        let startTime = time.set({
            hours: moment(availableShiftTime.end, "HH:mm").hour() - 1,
            minute: 0,
        });

        let endTime = moment(startTime, "HH:mm").clone().add(
            moment.duration(shiftHours.diff, "hours")
        );

        setFormData({
            shiftHours: {
                ...shiftHours,
                start: startTime.format("HH:mm"),
                end: endTime.format("HH:mm"),
            },
        });

        form.setFieldsValue({
            "start-time": startTime,
            "end-time": endTime,
        });
        return;
    }

    let startTime = time;

    let endTime = moment(startTime, "HH:mm").clone().add(
        moment.duration(shiftHours.diff, "hours")
    );
    setFormData({
        shiftHours: {
            ...shiftHours,
            start: startTime.format("HH:mm"),
            end: endTime.format("HH:mm"),
        },
    });

    form.setFieldsValue({
        "start-time": startTime,
        "end-time": endTime,
    });
    return;
};

export const startDisabledTime = ({
    availableShiftTime,
    endShiftTime,
    firstDisabledHours,
    fixedDisabledHours,
    shiftHours,
    selectedDay,
    isSootheMember,
    advanceBookingHours = ADDED_MARGIN_H,
}) => {
    const timeFormat = "HH:mm";
    const dateFormat = "YYYY-MM-DD";
    const firstAppointmentEnabledHour = moment(
        availableShiftTime?.start,
        timeFormat
    ).hour();
    const lastAppointmentEnabledHour = moment(
        availableShiftTime?.end,
        timeFormat
    ).hour();
    return {
        disabledHours: () => {
            let disabled = [...firstDisabledHours];
            // for (let i = 0; i < shiftHours.diff; i++) disabled.push(moment(availableShiftTime.end, "HH:mm").hours() - i);
            for (
                let i = moment(availableShiftTime.end, "HH:mm").hours();
                i <= DEFAULT_END_HOUR;
                i++
            ) {
                disabled.push(i);
            }
            for (
                let i = DEFAULT_START_HOUR;
                i < moment(availableShiftTime.start, "HH:mm").hours();
                i++
            ) {
                disabled.push(i);
            }

            for (
                let i = endShiftTime.hours();
                i <= moment(availableShiftTime.end, "HH:mm").hours();
                i++
            ) {
                if (endShiftTime.hours() !== 0) {
                    disabled.push(i);
                }
            }
            if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
                for (
                    let i = firstAppointmentEnabledHour;
                    i <= lastAppointmentEnabledHour;
                    i++
                ) {
                    if (isSootheMember) {
                        if (i < moment().hours()) {
                            disabled.push(i);
                        }
                        if (i === moment().hours() && moment().minutes() > 5) {
                            disabled.push(i);
                        }
                    } else {
                        if (i < moment().hours() + advanceBookingHours) {
                            disabled.push(i);
                        }
                        if (i === moment().hours() + advanceBookingHours && moment().minutes() > 57) {
                            disabled.push(i);
                        }
                    }
                }
            }
            return fixedDisabledHours.concat(disabled);
        },
        disabledMinutes: (selectedHour) => {
            const timeFormat = "HH:mm";
            const dateFormat = "YYYY-MM-DD";
            const availbleTimeRange = availableShiftTime;
            const firstAppointmentEnabledTime = moment(
                availbleTimeRange?.start,
                timeFormat
            );
            const lastAppointmentEnabledTime = moment(
                availbleTimeRange?.end,
                timeFormat
            );
            if (!availbleTimeRange) return;
            let minutes = [];

            if (selectedHour < 0) {
                for (let i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            } else if (selectedHour === firstAppointmentEnabledTime.hour()) {
                for (let i = firstAppointmentEnabledTime.minute() - 1; i >= 0; i--) {
                    minutes.push(i);
                }
            } else if (selectedHour === lastAppointmentEnabledTime.hour()) {
                for (let i = lastAppointmentEnabledTime.minute() + 1; i <= 60; i++) {
                    minutes.push(i);
                }
            }
            if (moment().format(dateFormat) === selectedDay?.format(dateFormat)) {
                if (isSootheMember) {
                    if (selectedHour === moment().hour()) {
                        for (let i = 0; i < moment().minute() + 30; i++) {
                            if (i <= 30) {
                                minutes.push(i);
                            }
                        }
                    } else if (selectedHour - 1 === moment().hour()) {
                        for (let i = 0; i < moment().minute() - 30; i++) {
                            if (i % 15 === 0) {
                                minutes.push(i);
                            }
                        }
                    }
                } else {
                    if (selectedHour === moment().hour() + advanceBookingHours) {
                        for (let i = 0; i < moment().minute(); i++) {
                            minutes.push(i);
                        }
                    }
                }
            }
            return minutes;
        },
    };
};

export const daysOfWeek = [
    { className: "day-tap", label: "Sat", value: 0 },
    { className: "day-tap", label: "Sun", value: 1 },
    { className: "day-tap", label: "Mon", value: 2 },
    { className: "day-tap", label: "Tue", value: 3 },
    { className: "day-tap", label: "Wed", value: 4 },
    { className: "day-tap", label: "Thu", value: 5 },
    { className: "day-tap", label: "Fri", value: 6 },
];
